'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GREEN = exports.GREEN = 'green';
var BLUE = exports.BLUE = 'blue';
var ORANGE = exports.ORANGE = 'orange';
var RED = exports.RED = 'red';
var NAVY = exports.NAVY = 'navy';
var DARK_GREEN = exports.DARK_GREEN = 'dark-green';
var DARK_THEME = exports.DARK_THEME = 'dark-theme';


//////////////////
// WEBPACK FOOTER
// ./src/components/ColorChooser/constants.js
// module id = 750
// module chunks = 0